export function optionInputValue<V>(value: V, index: number) {
  if (typeof value === 'string') {
    return value;
  }

  return String(index);
}

export function isOptionSelected<V>(value: V[], optionValue: V) {
  return value.some((item) => Object.is(item, optionValue));
}

export function toggleOptionValue<V>(
  value: V[],
  optionValue: V,
  selected: boolean,
) {
  if (selected) {
    if (isOptionSelected(value, optionValue)) {
      return value;
    }

    return [...value, optionValue];
  }

  return value.filter((item) => !Object.is(item, optionValue));
}
